import type { OnboardingSection } from "@rmh/defs";

/**
 * Shared React Query key root for onboarding-v2 section data.
 * Both `useStoreOnboardingSection` (invalidate on success) and
 * `useGetOnboardingSection` (cache read) build their key from this, so a
 * successful store invalidates exactly the entry the fetch hook reads and the
 * next read refetches the canonical value from Canvas.
 */
export const ONBOARDING_SECTION_QUERY_KEY = "onboarding";

export const onboardingSectionQueryKey = (
  patientId: string,
  section: OnboardingSection
) => [ONBOARDING_SECTION_QUERY_KEY, patientId, section] as const;
